// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"c9ba3810","98":"cde3c3e3","260":"cde3c3e3","278":"6a0b67e1","407":"12601ff7","417":"cde3c3e3","928":"c9ba3810"}[chunkId] + ".chunk.css";
};